<h2 mat-dialog-title>{{'dialogs.importLeadsFromFile.title' | translate}}
  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
</h2>
<div mat-dialog-content>
  <div class="dialogContent">
    <div [ngClass]="{
      'dragDropContainer': !isFileLoaded, 
      'dropContainerFileInfo': isFileLoaded, 
      'dropContainerResult': file && uploadResult}">
      <div class="fields">

        <ng-container *ngIf="!uploadResult">
          <div class="field">
            <autocomplete class="wide-field" [inputHtmlId]="'injectorInput'" [inputControl]="injectorForm"
              [autocompleteStrategy]="injectorIdSuggestionService" [label]="'Injector'"
              [placeHolder]="'cerca lead injector'" [loadOnClick]="true"
              (selectedSuggestion)="onSelectedInjectorSuggestion($event)"></autocomplete>
          </div>
        </ng-container>

        <ng-container *ngIf="!isFileLoaded">
          <div class="container-drag-drop" appDragDrop (files)="onFileDropped($event)">

            <div class="dragDropTextWrap">
              <div class="dragDropIconWrap">
                <mat-icon>file_upload</mat-icon>
              </div>
              <p>{{'dialogs.importLeadsFromFile.uploadDropText' | translate}}</p>

              <p>
                <a href="#" target="_blank"
                  (click)="onSearchFileClick(); $event.stopPropagation(); $event.preventDefault()">{{'dialogs.importLeadsFromFile.uploadSelectText' | translate}}</a>
              </p>

              <input type="file" id="fileInput" #fileInput [accept]="fileExtentions" style="display: none"
                (change)="onFileSelected($event.target!)" />
            </div>

          </div>
        </ng-container>

        <ng-container *ngIf="isFileLoaded">

          <ng-container *ngIf="file && !uploadResult else uploadResultTemplate">
            <div class="fileInfoContainer">
              <div class="fileInfoItems">
                <p>
                  <mat-icon>attachment</mat-icon>{{file.name}}
                </p>
                <p>
                  <mat-icon>calendar_today</mat-icon>{{file.lastModified | date: 'dd/MM/yyyy hh:mm'}}
                </p>
                <p>
                  <mat-icon>sd_storage</mat-icon>{{file.size | fileSize}}
                </p>
              </div>

            </div>
          </ng-container>

        </ng-container>


      </div>
    </div>

  </div>

</div>

<div class="buttons" mat-dialog-actions>
  <div *ngIf="isFileLoaded">
    <button mat-flat-button
      (click)="onLoadAgainButtonClick()">{{ (uploadResult ? 'dialogs.importLeadsFromFile.importOtherButtonText' : 'dialogs.importLeadsFromFile.chooseOtherText' ) |translate}}</button>
    <button *ngIf="!uploadResult" mat-flat-button color="primary" mat-raised-button
      (click)="onUploadClick()">{{'dialogs.importLeadsFromFile.importButtonText' | translate}}</button>
  </div>
</div>

<ng-template #uploadResultTemplate>
  <div class="resultInfoContainer">

    <p class="uploadResultText">
      <ng-container *ngIf="!uploadResult!.isSuccessfull && uploadResult!.error == lobbyErrorCode.MediaTypeUnsupported">
        <mat-icon>cancel</mat-icon>{{'messages.errors.MediaTypeUnsupported' | translate}}
      </ng-container>
      <ng-container *ngIf="!uploadResult!.isSuccessfull && uploadResult!.error == lobbyErrorCode.MediaEmpty">
        <mat-icon>cancel</mat-icon>{{'messages.errors.MediaEmpty' | translate}}
      </ng-container>
      <ng-container *ngIf="!uploadResult!.isSuccessfull && uploadResult!.error == lobbyErrorCode.MediaParseError">
        <mat-icon>cancel</mat-icon>{{'messages.errors.MediaParseError' | translate}}
      </ng-container>
      <ng-container *ngIf="uploadResult!.isSuccessfull">
        <mat-icon>check</mat-icon>{{'dialogs.importLeadsFromFile.successResultText' | translate}}
        {{uploadResult!.successfullyCreatedLeadsCount}}
      </ng-container>
    </p>
  </div>
</ng-template>
